import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Feed } from 'src/app/models/Feed';
import { AuthService } from 'src/app/services/auth.service';
import { FeedService } from 'src/app/services/modelService/feed.service';
import { ReactionService } from 'src/app/services/modelService/reaction.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class InfoComponent implements OnInit {
  descriptionHeight = "36vw";
  @Input() details = false;
  showAllReactions = false;
  hoverTimeout: any;
  @Input() feed: Feed = new Feed();

  showEmojiBox = false;
  constructor(public reactionService: ReactionService, public feedService: FeedService,
    private auth: AuthService, private router: Router, private platform: Platform) { }

  ngOnInit() {
    this.auth.getLoggedInEmployee();
    this.feedService.feed = this.feed;
    if(this.platform.width()>this.platform.height()){
      this.descriptionHeight = "10vw";
    }
  }

  clickEmoji(emoji) {
    this.showEmojiBox = false;
    this.reactionService.reaction.reaction = emoji;
    console.log(this.reactionService.reaction);
    this.feedService.sendMessage(this.feed);
  }

  viewFeedDetails() {
    this.router.navigate(['/post-details', this.feed.id]);
  }
}
